// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","summary":"PalletAmountSummary_summary__5HhG5","summaryTextLarge":"PalletAmountSummary_summaryTextLarge__4LuAZ"};